import React, { useEffect, useState } from "react";
import { SelectPicker, Table } from "rsuite";

const SelectEditCell = ({
  name,
  optionList,
  rowData,
  dataKey,
  onChange,
  ...props
}: {
  name: string;
  optionList: any;
  rowData: any;
  dataKey: any;
  onChange: Function;
}) => {
  const { Cell } = Table;
  const [value, setValue] = useState(rowData[dataKey]);

  useEffect(() => {
    setValue(rowData[dataKey]);
  }, [rowData, dataKey]);

  return (
    <Cell {...props} className={"table-content-editing"}>
      <SelectPicker
        data={optionList}
        valueKey="value"
        labelKey="label"
        onSelect={(value, item) => {
          const newValue = value;
          setValue(newValue);
          onChange && onChange(rowData.id, dataKey, newValue);
        }}
        onClean={(e: any) => {
          setValue("");
          onChange && onChange(rowData.id, dataKey, "");
        }}
        name={name}
        value={value}
      />
    </Cell>
  );
};

export default SelectEditCell;
